import {useEffect, useState} from "react";
import api from "../../../../utils/api";
import {setBottomBarError, setBottomBarSucces} from "../../../../utils/Functions";
import {useAppContext} from "../../../../context/Context";
import useIsModified from "../../../../hooks/useIsModified";

interface Configuration {
    questions_enabled: boolean;
    documents_upload_enabled: boolean;
    completions_model: string;
    tei_model: string;
    completions_request_limit: number;
    tei_request_limit: number;
}

export default function useConfiguration() {
    const [, dispatch] = useAppContext();
    const [configuration, setConfiguration] = useState<Configuration | null>(null);
    const [modifiedKeys, setModifiedKeys] = useState<string[]>([]);
    const {isModified, initialState, updateCachedState} = useIsModified(configuration);

    useEffect(() => {
        async function fetchConfiguration() {
            try {
                const response = await api.get("/configuration/");
                setConfiguration(response.data);
                updateCachedState();
            } catch (e) {
                setBottomBarError(dispatch, e);
            }
        }

        fetchConfiguration().catch(console.error);
    }, [dispatch, updateCachedState]);

    useEffect(() => {
        if (initialState !== null) {
            const result = [];
            for (const [k, v] of Object.entries(initialState)) {
                if (configuration[k] !== v) {
                    result.push(k);
                }
            }
            setModifiedKeys(result);
        }
    }, [configuration, initialState]);

    function editUnsavedConfiguration(keys: Partial<Configuration>) {
        setConfiguration(prevConfiguration => ({...prevConfiguration, ...keys}));
    }

    async function saveConfiguration(): Promise<boolean> {
        try {
            await api.patch("/configuration/", configuration);
        } catch (e) {
            setBottomBarError(dispatch, e);
            return false;
        }
        setBottomBarSucces(dispatch, "La configuration a été enregistrée");
        updateCachedState();
        return true;
    }

    return [
        {configuration, modifiedKeys, isModified},
        {editUnsavedConfiguration, saveConfiguration},
    ];
}